require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-basic-css-use-a-media-query-to-change-a-variable.json") })
        }
      }, "path---responsive-web-design-basic-css-use-a-media-query-to-change-a-variable");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-basic-css-use-a-media-query-to-change-a-variable!./.cache/json/responsive-web-design-basic-css-use-a-media-query-to-change-a-variable.json
// module id = 2619
// module chunks = 231608221292675